var React = require('react');

function Ruler (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M35.063 1.5a1.005 1.005 0 00-.594.313L1.875 34.406a.997.997 0 000 1.407L14.094 48.03a.999.999 0 001.437 0l32.594-32.593a.997.997 0 000-1.407L35.906 1.812a.985.985 0 00-.156-.156.992.992 0 00-.594-.156h-.093zm.124 2.438L46 14.75 14.812 45.906 4 35.125l2.844-2.844L9.28 34.72l1.438-1.438-2.438-2.437 2.563-2.563 5.437 5.438 1.438-1.438-5.438-5.437 2.563-2.563 2.437 2.438 1.438-1.438-2.438-2.437 2.563-2.563 5.437 5.438 1.438-1.438-5.438-5.437 2.563-2.563 2.437 2.438 1.438-1.438-2.438-2.437 2.563-2.563 5.437 5.438 1.438-1.438-5.438-5.437 2.563-2.563 2.437 2.438 1.44-1.44-2.44-2.436z"}));
}

Ruler.defaultProps = {"viewBox":"0 0 50 50"};

module.exports = Ruler;

Ruler.default = Ruler;
